import React, {Component} from 'react';
import getFieldFactory from "../../Endpoint/FieldFactory";
import FieldGroups from "../FieldGroups";
import {connect} from "react-redux";
import {addSubField} from "../../../../../store/actions/subFields";
import {FieldGroupContext} from "../../../../../contexts/FieldGroupContext";
import { UserFields } from '../../Endpoint/UserFields';
import ClassicOutputNotice from "../../../ClassicOutputNotice";
import {isOutputValid} from "../../../ClassicFunctions";

class Output extends Component {

	state = {
		selectedFilterToAdd: ''
	};

	handleSelectedFilterToAdd = (e) => {
		this.setState({selectedFilterToAdd: e.target.value});
	};

	render() {

		const {addSubField, group, premium} = this.props;

		let fields = [];

		UserFields.forEach((el) => {
			fields.push( getFieldFactory().getOnlyLabel( el.value, el.name ) );
		});

		fields.push(
			{
				name:   'custom-field',
				label:  'Custom field',
				fields: [
					{
						id:        'customFieldName',
						inputType: 'input',
						value:     '',
						label:     'Custom field name',
						dynamic:   false,
					},
          {
            id:        'customFieldNameDisplay',
            inputType: 'input',
            value:     '',
            label:     'Custom field name display',
            dynamic:   false,
          },
					{
						id: 'skipFirstLevel',
						inputType: 'select',
						source: 'yesNo',
						sourceName: 'name',
						sourceValue: 'value',
						value: '',
						label: 'Should skip the first level on arrays',
						defaultValue: 'Select an option',
					}
				],
			},
		);

		fields = fields.map(field => {
			field.fields = [...field.fields, ...getFieldFactory().getExtraFields()];
			return field;
		});

		return (
			<React.Fragment>
				<FieldGroupContext.Consumer>

					{({ endpointId, endpoint, currentItem, action }) => (<React.Fragment>
						<h3>Fields to display in the output: ({endpoint.displayUsers[currentItem].output.length})</h3>

						Select a field to output: <select value={this.state.selectedFilterToAdd} onChange={this.handleSelectedFilterToAdd}>
							<option value="">Select a field</option>
							{fields.sort((a, b) => (a.label > b.label) ? 1 : -1).map((el, index) => <option key={index} value={el.name}>{el.label}</option>)}
						</select>

						<button
							onClick={() => (premium || isOutputValid(endpoint.displayUsers[currentItem].output.length)) && addSubField(endpointId, fields.filter(el => el.name === this.state.selectedFilterToAdd), currentItem, group, action)}
							disabled={!this.state.selectedFilterToAdd ? 'disabled' : ''}
							className="button-secondary"
						>
							Add field
						</button>

            <ClassicOutputNotice />

						<FieldGroups group={group} />

					</React.Fragment>)}
				</FieldGroupContext.Consumer>
			</React.Fragment>
		);
	}
}

const mapStateToProps = ( state ) => ( state );

const mapDispatchToProps = dispatch => ({
	addSubField: ( endpointId, field, currentItem, group, parentGroup ) =>
    dispatch( addSubField( endpointId, field, currentItem, group, parentGroup ) ),
});

export default connect( mapStateToProps, mapDispatchToProps )(Output);
